import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/select';
import { IPhoneNumber } from '@models/advert/phone-number';
import { SupportedCountryCode } from '@models/backend/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'phone-number',
    templateUrl: 'phone-number.component.html',
    styleUrls: ['phone-number.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatInput, MatLabel, FormsModule, ReactiveFormsModule, TranslateModule],
})
export class PhoneNumberComponent implements OnChanges {
    readonly phoneNumber = input<IPhoneNumber>(undefined);
    readonly isMandatory = input<boolean>(undefined);
    readonly countryCode = input<SupportedCountryCode>(undefined);

    phoneForm: UntypedFormGroup;

    get isValid(): boolean {
        return this.phoneForm.valid;
    }

    get countryCodeTranslationKey(): string {
        switch (this.phoneNumber().phoneCountryCode) {
            case '+44':
                return 'SHARED_COMPONENT.COUNTRY_GB_PHONE';
            case '+49':
                return 'SHARED_COMPONENT.COUNTRY_DE_PHONE';
            case '+33':
                return 'SHARED_COMPONENT.COUNTRY_FR_PHONE';
            case '+1':
                return this.countryCode() === 'US'
                    ? 'SHARED_COMPONENT.COUNTRY_US_PHONE'
                    : 'SHARED_COMPONENT.COUNTRY_CA_PHONE';
            case '+357':
                return 'SHARED_COMPONENT.COUNTRY_CY_PHONE';
            case '+46':
                return 'SHARED_COMPONENT.COUNTRY_SE_PHONE';
            default:
                return 'SHARED_COMPONENT.COUNTRY_DE_PHONE';
        }
    }

    ngOnChanges(): void {
        const phoneNumber = this.phoneNumber();
        const areaCode = phoneNumber ? phoneNumber.phoneAreaCode : undefined;
        const phoneNumberValue = this.phoneNumber();
        const mainNumber = phoneNumberValue ? phoneNumberValue.mainNumber : undefined;

        this.phoneForm = new UntypedFormGroup({
            phoneAreaCode: new UntypedFormControl(areaCode, this.isMandatory() ? Validators.required : undefined),
            mainNumber: new UntypedFormControl(mainNumber, this.isMandatory() ? Validators.required : undefined),
        });
        this.phoneForm.markAllAsTouched();
        this.phoneForm.disable();
    }
}
